var BiFormSubmissionStatus = /* @__PURE__ */ ((BiFormSubmissionStatus2) => {
  BiFormSubmissionStatus2["INIT"] = "INITIATE_SUBMISSION";
  BiFormSubmissionStatus2["VALIDATION_FAILURE"] = "VALIDATION_FAILURE";
  BiFormSubmissionStatus2["FAILURE"] = "FAILURE";
  BiFormSubmissionStatus2["SUCCESS"] = "SUCCESS";
  return BiFormSubmissionStatus2;
})(BiFormSubmissionStatus || {});
export {
  BiFormSubmissionStatus
};
//# sourceMappingURL=bi.js.map
